"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7130],{

/***/ 61202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ l; }
});

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(46127);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/lib/clients.js + 4 modules
var clients = __webpack_require__(91264);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/lib/error-handler.js
var error_handler = __webpack_require__(36772);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/selling-plan.js
var selling_plan = __webpack_require__(55384);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/store-availability.js
var store_availability = __webpack_require__(72623);
;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/image.js
const n="\n  id\n  altText\n  width\n  height\n  url\n";
//# sourceMappingURL=image.js.map

;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/media.js
const e=`\n  __typename\n  ... on Video {\n    mediaContentType\n    id\n    alt\n    previewImage {\n      ${n}\n    }\n    sources {\n      url\n      width\n      height\n    }\n  }\n\n  ... on MediaImage {\n    id\n    mediaContentType\n    image {\n      ${n}\n    }\n  }\n  ... on ExternalVideo {\n    mediaContentType\n    id\n  }\n  ... on Model3d {\n    mediaContentType\n    id\n  }\n`;
//# sourceMappingURL=media.js.map

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/metafields.js
var metafields = __webpack_require__(19841);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/price.js
var price = __webpack_require__(18928);
;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/variant-components.js
const i=`\nnodes {\n  productVariant {\n    id\n    title\n    sku\n    availableForSale\n\n    metafields(identifiers: $metafieldVariantComponentIdentifiers)\n      @include(if: $includeMetafieldVariantComponentIdentifiers) {\n      ${metafields/* STOREFRONT_METAFIELD_FRAGMENT */.N}\n    }\n\n    image @include(if: $includeVariantComponentImage) {\n      ${n}\n    }\n\n    product {\n      id\n      title\n\n      metafields(identifiers: $metafieldVariantComponentProductIdentifiers)\n        @include(if: $includeMetafieldVariantComponentProductIdentifiers) {\n        ${metafields/* STOREFRONT_METAFIELD_FRAGMENT */.N}\n      }\n    }\n  }\n}\n`;
//# sourceMappingURL=variant-components.js.map

;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/product.js
const d=`\n__typename\navailableForSale\nid\ntitle\nhandle\npublishedAt\ncreatedAt\nupdatedAt\nproductType\nisGiftCard\ntags @include(if: $includeTags)\nseo @include(if: $includeSeo) {\n  title\n  description\n}\ndescriptionHtml @include(if: $includeDescriptionHtml)\n\nvendor\ndescription\nmetafields(identifiers: $metafieldIdentifiers)\n  @include(if: $includeMetafields) {\n  ${metafields/* STOREFRONT_METAFIELD_FRAGMENT */.N}\n}\nfeaturedImage @include(if: $includeFeaturedImage) {\n  ${n}\n}\n\ncompareAtPriceRange @include(if: $includePrices) {\n  minVariantPrice {\n    ${price/* STOREFRONT_PRICE_FRAGMENT */.E}\n  }\n  maxVariantPrice {\n    ${price/* STOREFRONT_PRICE_FRAGMENT */.E}\n  }\n}\n\npriceRange @include(if: $includePrices) {\n  minVariantPrice {\n    ${price/* STOREFRONT_PRICE_FRAGMENT */.E}\n  }\n  maxVariantPrice {\n    ${price/* STOREFRONT_PRICE_FRAGMENT */.E}\n  }\n}\n\ncollections(first: $collectionsFirst) @include(if: $includeCollections) {\n  nodes {\n    id\n    handle\n    title\n\n    metafields(identifiers: $metafieldCollectionsIdentifiers)\n      @include(if: $includeCollectionsMetafields) {\n      ${metafields/* STOREFRONT_METAFIELD_FRAGMENT */.N}\n    }\n  }\n}\n\n sellingPlanGroups(first: $sellingPlanGroupsFirst) @include(if: $includeSellingPlanGroups) {\n    nodes {\n      appName\n      name\n      options {\n        name\n        values\n      }\n      sellingPlans(first: $sellingPlanGroupsSellingPlansFirst) {\n        nodes {\n          ${selling_plan/* STOREFRONT_SELLING_PLAN_FRAGMENT */.F}\n        }\n      }\n    }\n  }\n\nvariants(first: $variantsFirst) @include(if: $includeVariants) {\n  nodes {\n    id\n    title\n    sku\n    availableForSale\n    barcode\n    currentlyNotInStock\n    requiresComponents\n    quantityAvailable @include(if: $includeQuantityAvailable)\n    weight @include(if: $includeWeight)\n    weightUnit @include(if: $includeWeight)\n\n    image {\n      ${n}\n    }\n    selectedOptions @include(if: $includeSelectedOptions) {\n      name\n      value\n    }\n\n    price @include(if: $includePrices) {\n      ${price/* STOREFRONT_PRICE_FRAGMENT */.E}\n    }\n\n    compareAtPrice @include(if: $includePrices) {\n      ${price/* STOREFRONT_PRICE_FRAGMENT */.E}\n    }\n\n    storeAvailability(first: $storeAvailabilityFirst) @include(if: $includeStoreAvailability) {\n      ${store_availability/* STOREFRONT_STORE_AVAILABILITY_FRAGMENT */.q}\n    }\n\n    metafields(identifiers: $metafieldVariantsIdentifiers)\n      @include(if: $includeVariantsMetafields) {\n      ${metafields/* STOREFRONT_METAFIELD_FRAGMENT */.N}\n    }\n\n    components(first: $variantComponentsFirst) @include(if: $includeVariantComponents) {\n      ${i}\n    }\n  }\n}\n\nimages(first: $imagesFirst) @include(if: $includeImages) {\n  nodes {\n    ${n}\n  }\n}\n\nmedia(first: $mediaFirst) @include(if: $includeMedia) {\n  nodes {\n    ${e}\n  }\n}`,o="\n    $includeQuantityAvailable: Boolean!\n    $includePrices: Boolean!\n    $includeTags: Boolean!\n    $includeSeo: Boolean!\n    $includeDescriptionHtml: Boolean!\n    $includeWeight: Boolean!\n    $includeSelectedOptions: Boolean!\n    $includeFeaturedImage: Boolean!\n    $variantsFirst: Int\n    $includeVariants: Boolean!\n    $mediaFirst: Int\n    $includeMedia: Boolean!\n    $collectionsFirst: Int\n    $includeCollections: Boolean!\n    $imagesFirst: Int\n    $includeImages: Boolean!\n    $storeAvailabilityFirst: Int\n    $includeStoreAvailability: Boolean!\n    $includeMetafields: Boolean!\n    $metafieldIdentifiers: [HasMetafieldsIdentifier!]!\n    $includeCollectionsMetafields: Boolean!\n    $metafieldCollectionsIdentifiers: [HasMetafieldsIdentifier!]!\n    $includeVariantsMetafields: Boolean!\n    $metafieldVariantsIdentifiers: [HasMetafieldsIdentifier!]!\n    $includeSellingPlanGroups: Boolean!\n    $sellingPlanGroupsFirst: Int\n    $sellingPlanGroupsSellingPlansFirst: Int\n    $includeVariantComponents: Boolean!\n    $variantComponentsFirst: Int\n    $metafieldVariantComponentIdentifiers: [HasMetafieldsIdentifier!]!\n    $includeMetafieldVariantComponentIdentifiers: Boolean!\n    $metafieldVariantComponentProductIdentifiers: [HasMetafieldsIdentifier!]!\n    $includeMetafieldVariantComponentProductIdentifiers: Boolean!\n    $includeVariantComponentImage: Boolean!\n";
//# sourceMappingURL=product.js.map

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/products/utils/serializers.js + 7 modules
var serializers = __webpack_require__(77559);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/lib/metafields.js
var lib_metafields = __webpack_require__(65567);
;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/products/utils/unlikelyProductInputToProductRequestParams.js
function unlikelyProductInputToProductRequestParams_i(i){const{includeQuantityAvailable:n=!1,includePrices:l=!1,includeTags:t=!1,includeSeo:a=!1,includeDescriptionHtml:s=!1,includeSelectedOptions:d=!1,includeFeaturedImage:r=!1,includeWeight:o=!1,variantsFirst:u,mediaFirst:c,collectionsFirst:m,imagesFirst:f,storeAvailabilityFirst:g,metafieldKeys:p,metafieldCollectionsKeys:F,metafieldVariantsKeys:v,sellingPlanGroupsFirst:C,sellingPlanGroupsSellingPlansFirst:I,variantComponentsFirst:P,variantComponentProductMetafieldKeys:V,variantComponentMetafieldKeys:y,includeVariantComponentImage:M=!1}=i,S=(0,lib_metafields/* getMetafieldIdentifiers */.w)(p),h=(0,lib_metafields/* getMetafieldIdentifiers */.w)(v),b=(0,lib_metafields/* getMetafieldIdentifiers */.w)(F),A=(0,lib_metafields/* getMetafieldIdentifiers */.w)(y),G=(0,lib_metafields/* getMetafieldIdentifiers */.w)(V);return{includeQuantityAvailable:n,includePrices:l,includeTags:t,includeSeo:a,includeDescriptionHtml:s,includeSelectedOptions:d,includeFeaturedImage:r,variantsFirst:u,includeVariants:(null!=u?u:0)>0,includeWeight:o,mediaFirst:c,includeMedia:(null!=c?c:0)>0,collectionsFirst:m,includeCollections:(null!=m?m:0)>0,imagesFirst:f,includeImages:(null!=f?f:0)>0,storeAvailabilityFirst:g,includeStoreAvailability:(null!=g?g:0)>0,includeMetafields:S.length>0,metafieldIdentifiers:S,includeCollectionsMetafields:(null==b?void 0:b.length)>0,metafieldCollectionsIdentifiers:b,includeVariantsMetafields:(null==h?void 0:h.length)>0,metafieldVariantsIdentifiers:h,sellingPlanGroupsFirst:C,includeSellingPlanGroups:(null!=C?C:0)>0,sellingPlanGroupsSellingPlansFirst:I,variantComponentsFirst:P,includeVariantComponentImage:M,includeVariantComponents:(null!=P?P:0)>0,includeMetafieldVariantComponentIdentifiers:(null==A?void 0:A.length)>0,metafieldVariantComponentIdentifiers:A,includeMetafieldVariantComponentProductIdentifiers:(null==G?void 0:G.length)>0,metafieldVariantComponentProductIdentifiers:G}}
//# sourceMappingURL=unlikelyProductInputToProductRequestParams.js.map

;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/products/queries/product.js
const product_d=dist.gql`
  query getProductById(
    $id: ID!
    $language: LanguageCode
    $country: CountryCode
    ${o}
  ) @inContext(language: $language, country: $country) {
    product(id: $id) {
      ${d}
    }
  }
`,l=(0,clients/* shopifyStorefrontClientWrapper */.Jr)(((o,u)=>(0,tslib_es6/* __awaiter */.m)(void 0,void 0,void 0,(function*(){const r=yield o.request(product_d,Object.assign({id:u.id,country:u.country,language:u.language},unlikelyProductInputToProductRequestParams_i(u)));return{errors:(0,error_handler/* handleError */.S3)(null==r?void 0:r.errors),product:(null==r?void 0:r.product)?(0,serializers/* shopifyProductToUnlikelyProduct */.ed)(r.product):null}}))));
//# sourceMappingURL=product.js.map


/***/ }),

/***/ 38137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ c; }
/* harmony export */ });
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57891);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function c({className:i,color:o="#000000",size:e=41,strokeWidth:n=1}){const s={originX:"50%",originY:"50%"},p={strokeLinecap:"round"},r=e*.5;return react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_1__.m.svg,{className:i,viewBox:`0 0 ${e} ${e}`,animate:{rotate:360},transition:{repeat:1/0,duration:1.5,ease:"linear"},style:s},react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_1__.m.circle,{cx:r,cy:r,r:r-1,fill:"none",strokeWidth:n,stroke:o,style:p,animate:{strokeDasharray:["1px, 150px","90px, 150px","90px, 150px"],strokeDashoffset:[0,-35,-124]},transition:{repeat:1/0,duration:1.5,ease:"linear"}}))}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 25291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ B; }
});

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/AnalyticsProvider/index.js
var AnalyticsProvider = __webpack_require__(13711);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/AnalyticsProvider/utils/fromCartDataToCartEventPayload.js
var fromCartDataToCartEventPayload = __webpack_require__(23752);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/AnalyticsProvider/utils/fromCartLineToAnalyticsProduct.js
var fromCartLineToAnalyticsProduct = __webpack_require__(68889);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/CartProvider/hooks/useCartContext.js
var useCartContext = __webpack_require__(74197);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/StoreProvider/index.js + 2 modules
var StoreProvider = __webpack_require__(45440);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(46127);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/cart/utils/serializers.js
var serializers = __webpack_require__(38425);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/cart/utils/unlikelyCartInputToCartRequestParams.js
var unlikelyCartInputToCartRequestParams = __webpack_require__(60680);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/cart.js
var cart = __webpack_require__(38049);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/errors.js
var errors = __webpack_require__(5019);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/lib/clients.js + 4 modules
var clients = __webpack_require__(91264);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/lib/error-handler.js
var error_handler = __webpack_require__(36772);
;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/cart/mutations/cartLinesAdd.js
const c=dist.gql`
  mutation cartLinesAdd(
    $lines: [CartLineInput!]!
    $cartId: ID!
    ${cart/* CART_PARAMS */.PY}
  ) @inContext(language: $language, country: $country) {
    cartLinesAdd(lines: $lines, cartId: $cartId) {
      cart {
        ${cart/* CART_FIELDS */.w_}
      }
      ${errors/* CART_USER_ERRORS_FRAGMENT */._}
    }
  }`,u=(0,clients/* shopifyStorefrontClientWrapper */.Jr)(((i,e)=>(0,tslib_es6/* __awaiter */.m)(void 0,void 0,void 0,(function*(){var r,n,{cartId:a,lines:l}=e,u=(0,tslib_es6/* __rest */._)(e,["cartId","lines"]);const m=yield i.request(c,Object.assign({cartId:a,lines:l},(0,unlikelyCartInputToCartRequestParams/* unlikelyCartInputToCartRequestParams */.m)(u)));return{cart:(null===(r=null==m?void 0:m.cartLinesAdd)||void 0===r?void 0:r.cart)?(0,serializers/* shopifyCartToUnlikelyCart */.Z)(m.cartLinesAdd.cart):null,errors:(0,error_handler/* handleError */.S3)(null===(n=null==m?void 0:m.cartLinesAdd)||void 0===n?void 0:n.userErrors)}}))));
//# sourceMappingURL=cartLinesAdd.js.map

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/cart/useGetCart/index.js + 1 modules
var useGetCart = __webpack_require__(56729);
;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/cart/useAddCartLines/index.js
var q=Object.defineProperty,k=Object.defineProperties,D=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,M=Object.prototype.hasOwnProperty,U=Object.prototype.propertyIsEnumerable,f=(e,r,t)=>r in e?q(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,a=(e,r)=>{for(var t in r||(r={}))M.call(r,t)&&f(e,t,r[t]);if(d)for(var t of d(r))U.call(r,t)&&f(e,t,r[t]);return e},l=(e,r)=>k(e,D(r));function B(e={}){const r=(0,QueryClientProvider/* useQueryClient */.NL)(),t=(0,useGetCart/* useGetCartQueryKey */.w)(),{cartId:y,cartInput:v}=(0,useCartContext/* useCartContext */.i)(),{storefrontAccessToken:b,storeUrl:C,language:O,country:g}=(0,StoreProvider/* useStoreContext */.Q)(),A=(0,AnalyticsProvider/* useEmitAnalyticsEvent */.cE)();return (0,useMutation/* useMutation */.D)(l(a({mutationFn:n=>u({storefrontAccessToken:b,storeUrl:C},a({cartId:y,lines:n,language:O,country:g},v))},e),{onSuccess:(n,i,j)=>{var u,s;const o=n.cart;o&&r.setQueryData(t,{cart:o,errors:[]}),A("addToCart",l(a({},(0,fromCartDataToCartEventPayload/* default */.Z)(o)),{products:(u=i?.map(c=>{var m;const p=(m=o?.lines)==null?void 0:m.find(I=>I.merchandise.id===c.merchandiseId);return p?(0,fromCartLineToAnalyticsProduct/* fromCartLineToAnalyticsProduct */.J)(l(a({},p),{quantity:c.quantity})):null}).filter(Boolean))!=null?u:[]})),r.invalidateQueries(t),(s=e?.onSuccess)==null||s.call(e,n,i,j)}}))}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 90646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ k; }
});

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/CartProvider/hooks/useCartContext.js
var useCartContext = __webpack_require__(74197);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/StoreProvider/index.js + 2 modules
var StoreProvider = __webpack_require__(45440);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/utils/merge-custom-attributes.js
var merge_custom_attributes = __webpack_require__(31986);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(46127);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/cart/utils/serializers.js
var serializers = __webpack_require__(38425);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/cart/utils/unlikelyCartInputToCartRequestParams.js
var unlikelyCartInputToCartRequestParams = __webpack_require__(60680);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/cart.js
var cart = __webpack_require__(38049);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/errors.js
var errors = __webpack_require__(5019);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/lib/clients.js + 4 modules
var clients = __webpack_require__(91264);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/lib/error-handler.js
var error_handler = __webpack_require__(36772);
;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/cart/mutations/cartAttributesUpdate.js
const d=dist.gql`
  mutation cartAttributesUpdate(
    $cartId: ID!
    $attributes: [AttributeInput!]!
    ${cart/* CART_PARAMS */.PY}

  ) @inContext(language: $language, country: $country) {
    cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
      cart {
        ${cart/* CART_FIELDS */.w_}
      }
      ${errors/* CART_USER_ERRORS_FRAGMENT */._}
    }
  }`,cartAttributesUpdate_c=(0,clients/* shopifyStorefrontClientWrapper */.Jr)(((e,s)=>(0,tslib_es6/* __awaiter */.m)(void 0,void 0,void 0,(function*(){var t,o,{cartId:u,attributes:l}=s,c=(0,tslib_es6/* __rest */._)(s,["cartId","attributes"]);const m=yield e.request(d,Object.assign({cartId:u,attributes:l},(0,unlikelyCartInputToCartRequestParams/* unlikelyCartInputToCartRequestParams */.m)(c)));return{cart:(null===(t=null==m?void 0:m.cartAttributesUpdate)||void 0===t?void 0:t.cart)?(0,serializers/* shopifyCartToUnlikelyCart */.Z)(m.cartAttributesUpdate.cart):null,errors:(0,error_handler/* handleError */.S3)(null===(o=null==m?void 0:m.cartAttributesUpdate)||void 0===o?void 0:o.userErrors)}}))));
//# sourceMappingURL=cartAttributesUpdate.js.map

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/cart/useGetCart/index.js + 1 modules
var useGetCart = __webpack_require__(56729);
;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/cart/useUpdateCartAttributes/index.js
var D=Object.defineProperty,P=Object.defineProperties,x=Object.getOwnPropertyDescriptors,b=Object.getOwnPropertySymbols,E=Object.prototype.hasOwnProperty,I=Object.prototype.propertyIsEnumerable,f=(t,r,e)=>r in t?D(t,r,{enumerable:!0,configurable:!0,writable:!0,value:e}):t[r]=e,s=(t,r)=>{for(var e in r||(r={}))E.call(r,e)&&f(t,e,r[e]);if(b)for(var e of b(r))I.call(r,e)&&f(t,e,r[e]);return t},M=(t,r)=>P(t,x(r));function k(t={},r){const e=(0,QueryClientProvider/* useQueryClient */.NL)(),u=(0,useGetCart/* useGetCartQueryKey */.w)(),{cartId:d,cartInput:m,disableOptimisticUpdates:c}=(0,useCartContext/* useCartContext */.i)(),{storeUrl:v,storefrontAccessToken:y,language:O,country:g}=(0,StoreProvider/* useStoreContext */.Q)(),p=c??r?.disableOptimisticUpdate;return (0,useMutation/* useMutation */.D)(M(s({mutationFn:o=>cartAttributesUpdate_c({storefrontAccessToken:y,storeUrl:v},s(s({cartId:d,language:O,country:g},m),o))},t),{onMutate:async o=>{var i,n;const a=e.getQueryData(u);if(!p){await e.cancelQueries(u);const l=JSON.parse(JSON.stringify(a));o.attributes&&((i=a?.cart)==null?void 0:i.attributes)&&(l.cart.attributes=(0,merge_custom_attributes/* mergeCustomAttributes */.P)(a.cart.attributes,o.attributes)),e.setQueryData(u,l)}return(n=t?.onMutate)==null||n.call(t,o),{previousCart:a}},onError:(o,i,n)=>{var a;p||e.setQueryData(u,n.previousCart),(a=t?.onError)==null||a.call(t,o,i,n)},onSettled:(o,i,n,a)=>{var l;e.invalidateQueries(u),(l=t?.onSettled)==null||l.call(t,o,i,n,a)}}))}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 55522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ Y; }
});

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/CartProvider/hooks/useCartContext.js
var useCartContext = __webpack_require__(74197);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/StoreProvider/index.js + 2 modules
var StoreProvider = __webpack_require__(45440);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/AnalyticsProvider/index.js
var AnalyticsProvider = __webpack_require__(13711);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/AnalyticsProvider/utils/fromCartDataToCartEventPayload.js
var fromCartDataToCartEventPayload = __webpack_require__(23752);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/AnalyticsProvider/utils/fromCartLineToAnalyticsProduct.js
var fromCartLineToAnalyticsProduct = __webpack_require__(68889);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/utils/merge-custom-attributes.js
var merge_custom_attributes = __webpack_require__(31986);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(46127);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/cart/utils/serializers.js
var serializers = __webpack_require__(38425);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/cart/utils/unlikelyCartInputToCartRequestParams.js
var unlikelyCartInputToCartRequestParams = __webpack_require__(60680);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/cart.js
var cart = __webpack_require__(38049);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/fragments/errors.js
var errors = __webpack_require__(5019);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/lib/clients.js + 4 modules
var clients = __webpack_require__(91264);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/lib/error-handler.js
var error_handler = __webpack_require__(36772);
;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/api/shopify/storefront/cart/mutations/cartLinesUpdate.js
const c=dist.gql`
  mutation cartLinesUpdate(
    $lines: [CartLineUpdateInput!]!
    $cartId: ID!
    ${cart/* CART_PARAMS */.PY}
  ) @inContext(language: $language, country: $country) {
    cartLinesUpdate(lines: $lines, cartId: $cartId) {
      cart {
        ${cart/* CART_FIELDS */.w_}
      }
      ${errors/* CART_USER_ERRORS_FRAGMENT */._}
    }
  }`,u=(0,clients/* shopifyStorefrontClientWrapper */.Jr)(((e,o)=>(0,tslib_es6/* __awaiter */.m)(void 0,void 0,void 0,(function*(){var r,a,{cartId:n,lines:l}=o,u=(0,tslib_es6/* __rest */._)(o,["cartId","lines"]);const m=yield e.request(c,Object.assign({cartId:n,lines:l},(0,unlikelyCartInputToCartRequestParams/* unlikelyCartInputToCartRequestParams */.m)(u)));return{cart:(null===(r=null==m?void 0:m.cartLinesUpdate)||void 0===r?void 0:r.cart)?(0,serializers/* shopifyCartToUnlikelyCart */.Z)(m.cartLinesUpdate.cart):null,errors:(0,error_handler/* handleError */.S3)(null===(a=null==m?void 0:m.cartLinesUpdate)||void 0===a?void 0:a.userErrors)}}))));
//# sourceMappingURL=cartLinesUpdate.js.map

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/node_modules/awesome-debounce-promise/dist/index.es.js + 3 modules
var index_es = __webpack_require__(50964);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/packages/react-ecommerce-hooks/types/commerce-connector/index.js
function commerce_connector_t(i){return/^gid:\/\/shopify\/[^\/]+\/\d+(?:\?.*)?$/.test(i)}
//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/cart/useGetCart/index.js + 1 modules
var useGetCart = __webpack_require__(56729);
;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/cart/useUpdateCartLines/index.js
var z=Object.defineProperty,H=Object.defineProperties,V=Object.getOwnPropertyDescriptors,A=Object.getOwnPropertySymbols,W=Object.prototype.hasOwnProperty,X=Object.prototype.propertyIsEnumerable,D=(t,r,e)=>r in t?z(t,r,{enumerable:!0,configurable:!0,writable:!0,value:e}):t[r]=e,v=(t,r)=>{for(var e in r||(r={}))W.call(r,e)&&D(t,e,r[e]);if(A)for(var e of A(r))X.call(r,e)&&D(t,e,r[e]);return t},y=(t,r)=>H(t,V(r));function Y(t={},r){const e=(0,QueryClientProvider/* useQueryClient */.NL)(),f=(0,useGetCart/* useGetCartQueryKey */.w)(),{storeUrl:E,storefrontAccessToken:I,language:P,country:w}=(0,StoreProvider/* useStoreContext */.Q)(),O=(0,AnalyticsProvider/* useEmitAnalyticsEvent */.cE)(),{cartId:g,cartInput:T,disableOptimisticUpdates:h}=(0,useCartContext/* useCartContext */.i)(),L=(0,react.useMemo)(()=>(0,index_es/* default */.Z)(n=>u({storefrontAccessToken:I,storeUrl:E},v({cartId:g,language:P,country:w,lines:n},T)),350),[g]),Q=h??r?.disableOptimisticUpdate;return (0,useMutation/* useMutation */.D)(y(v({mutationFn:L},t),{onMutate:async n=>{var l,a,u,s;const c=e.getQueryData(f);if(!Q){await e.cancelQueries(f);const d=JSON.parse(JSON.stringify(c));(l=c?.cart)!=null&&l.lines&&(d.cart.lines=(u=(a=d.cart.lines)==null?void 0:a.map(i=>{const C=i?.id,o=n?.find(b=>b?.id===C);return typeof o?.quantity=="number"&&(i.quantity=o.quantity),o!=null&&o.attributes&&(i.attributes=(0,merge_custom_attributes/* mergeCustomAttributes */.P)(i.attributes,o.attributes)),o?.merchandiseId&&commerce_connector_t(o.merchandiseId)&&(i.merchandise.id=o.merchandiseId),i}))==null?void 0:u.filter(i=>i?.quantity>0)),e.setQueryData(f,d)}return(s=t?.onMutate)==null||s.call(t,n),{previousCart:c}},onSuccess:(n,l,a)=>{var u;const s=n?.cart;s&&e.setQueryData(f,{cart:v({},s),errors:[]});let c=[],d=[];l?.forEach(i=>{var C,o,b,S;const p=(b=(o=(C=a.previousCart)==null?void 0:C.cart)==null?void 0:o.lines)==null?void 0:b.find(q=>q?.id===i?.id),m=(S=s?.lines)==null?void 0:S.find(q=>q?.id===i?.id);m?m.quantity&&m.quantity>p.quantity?c=[...c,y(v({},m),{quantity:m.quantity-p.quantity})]:m.quantity<p.quantity&&(d=[...d,y(v({},m),{quantity:p.quantity-m.quantity})]):d=[...d,y(v({},p),{quantity:p?.quantity})]}),c.length>0&&O("addToCart",y(v({},(0,fromCartDataToCartEventPayload/* default */.Z)(n.cart)),{products:c.map(fromCartLineToAnalyticsProduct/* fromCartLineToAnalyticsProduct */.J)})),d.length>0&&O("removeFromCart",y(v({},(0,fromCartDataToCartEventPayload/* default */.Z)(n.cart)),{products:d.map(fromCartLineToAnalyticsProduct/* fromCartLineToAnalyticsProduct */.J)})),(u=t?.onSuccess)==null||u.call(t,n,l,a)},onError:(n,l,a)=>{var u;Q||e.setQueryData(f,a.previousCart),(u=t?.onError)==null||u.call(t,n,l,a)},onSettled:(n,l,a,u)=>{var s;e.invalidateQueries(f),(s=t?.onSettled)==null||s.call(t,n,l,a,u)}}))}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 50964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ g; }
});

;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/node_modules/debounce-promise/dist/index.js
var T=function(r){var o=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0,u=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{},s=void 0,t=void 0,l=void 0,n=[];return function(){var d=P(o),v=new Date().getTime(),g=!s||v-s>d;s=v;for(var f=arguments.length,i=Array(f),a=0;a<f;a++)i[a]=arguments[a];if(g&&u.leading)return u.accumulate?Promise.resolve(r.call(this,[i])).then(function(m){return m[0]}):Promise.resolve(r.call.apply(r,[this].concat(i)));if(t?clearTimeout(l):t=b(),n.push(i),l=setTimeout(h.bind(this),d),u.accumulate){var p=n.length-1;return t.promise.then(function(m){return m[p]})}return t.promise};function h(){var c=t;clearTimeout(l),Promise.resolve(u.accumulate?r.call(this,n):r.apply(this,n[n.length-1])).then(c.resolve,c.reject),n=[],t=null}};function P(e){return typeof e=="function"?e():e}function b(){var e={};return e.promise=new Promise(function(r,o){e.resolve=r,e.reject=o}),e}
//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/node_modules/awesome-imperative-promise/dist/index.es.js
function u(t){var e=null,r=null,o=new Promise(function(n,c){e=n,r=c});return t&&t.then(function(n){e&&e(n)},function(n){r&&r(n)}),{promise:o,resolve:function(n){e&&e(n)},reject:function(n){r&&r(n)},cancel:function(){e=null,r=null}}}
//# sourceMappingURL=index.es.js.map

;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/node_modules/awesome-only-resolves-last-promise/dist/index.es.js
function v(o){var e=null,t=function(){for(var a=[],r=0;r<arguments.length;r++)a[r]=arguments[r];e&&e();var i=o.apply(void 0,a),n=u(i),s=n.promise,c=n.cancel;return e=c,s};return t}
//# sourceMappingURL=index.es.js.map

;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/node_modules/awesome-debounce-promise/dist/index.es.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */var a=function(){return a=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++){t=arguments[n];for(var i in t)Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i])}return e},a.apply(this,arguments)},l={key:function(){return null},onlyResolvesLast:!0},d=function(){function o(e){this.config=e,this.debounceSingleton=null,this.debounceCache={}}return o.prototype._createDebouncedFunction=function(){var e=T(this.config.func,this.config.wait,this.config.options);return this.config.options.onlyResolvesLast&&(e=v(e)),{func:e}},o.prototype.getDebouncedFunction=function(e){var t,n=(t=this.config.options).key.apply(t,e);return n===null||typeof n>"u"?(this.debounceSingleton||(this.debounceSingleton=this._createDebouncedFunction()),this.debounceSingleton):(this.debounceCache[n]||(this.debounceCache[n]=this._createDebouncedFunction()),this.debounceCache[n])},o}();function g(o,e,t){var n=a({},l,t),r=new d({func:o,wait:e,options:n}),i=function(){for(var c=[],u=0;u<arguments.length;u++)c[u]=arguments[u];var s=r.getDebouncedFunction(c).func;return s.apply(void 0,c)};return i}
//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ 31986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ c; }
/* harmony export */ });
function c(t,n){return t.concat(n).reduce((e,r)=>e.find(u=>u.key===r.key)?e:[...e,r],[])}
//# sourceMappingURL=merge-custom-attributes.js.map


/***/ }),

/***/ 9011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ o; },
/* harmony export */   "h": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var _utils_can_use_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53586);
var o=(e=>(e.mobile="mobile",e.desktop="desktop",e))(o||{});function t(){let e=!1;return function(i){(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(i)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(i.substr(0,4)))&&(e=!0)}(navigator.userAgent||navigator.vendor||window.opera),e}const m=_utils_can_use_dom_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z&&t()?"mobile":"desktop";function n(){return m}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 80581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function t(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({addOffset:()=>{},setOffset:()=>{},dragState:null,defaultBounds:{top:0,bottom:0,left:0,right:0},setSlideIndex:()=>{},nextSlide:()=>{},prevSlide:()=>{},slideIndex:0,maxSlideIndex:0,enableDrag:!0})}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 51438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 52951:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ }),

/***/ 16567:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 60119:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}


/***/ }),

/***/ 60315:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ ae; }
/* harmony export */ });
/* unused harmony exports RichtextResolver, RichtextSchema, STORYBLOK_AGENT, STORYBLOK_JS_CLIENT_AGENT, SbFetch, SbHelpers */
var S = Object.defineProperty;
var x = (o, e, t) => e in o ? S(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t;
var c = (o, e, t) => x(o, typeof e != "symbol" ? e + "" : e, t);
function v(o) {
  return !(o !== o || o === 1 / 0 || o === -1 / 0);
}
function P(o, e, t) {
  if (!v(e))
    throw new TypeError("Expected `limit` to be a finite number");
  if (!v(t))
    throw new TypeError("Expected `interval` to be a finite number");
  const r = [];
  let s = [], i = 0;
  const n = function() {
    i++;
    const a = setTimeout(function() {
      i--, r.length > 0 && n(), s = s.filter(function(h) {
        return h !== a;
      });
    }, t);
    s.indexOf(a) < 0 && s.push(a);
    const u = r.shift();
    u.resolve(o.apply(u.self, u.args));
  }, l = function(...a) {
    const u = this;
    return new Promise(function(h, f) {
      r.push({
        resolve: h,
        reject: f,
        args: a,
        self: u
      }), i < e && n();
    });
  };
  return l.abort = function() {
    s.forEach(clearTimeout), s = [], r.forEach(function(a) {
      a.reject(function() {
        Error.call(this, "Throttled function aborted"), this.name = "AbortError";
      });
    }), r.length = 0;
  }, l;
}
class k {
  constructor() {
    c(this, "isCDNUrl", (e = "") => e.indexOf("/cdn/") > -1);
    c(this, "getOptionsPage", (e, t = 25, r = 1) => ({
      ...e,
      per_page: t,
      page: r
    }));
    c(this, "delay", (e) => new Promise((t) => setTimeout(t, e)));
    c(this, "arrayFrom", (e = 0, t) => [...Array(e)].map(t));
    c(this, "range", (e = 0, t = e) => {
      const r = Math.abs(t - e) || 0, s = e < t ? 1 : -1;
      return this.arrayFrom(r, (i, n) => n * s + e);
    });
    c(this, "asyncMap", async (e, t) => Promise.all(e.map(t)));
    c(this, "flatMap", (e = [], t) => e.map(t).reduce((r, s) => [...r, ...s], []));
    /**
     * @method escapeHTML
     * @param  {String} string text to be parsed
     * @return {String} Text parsed
     */
    c(this, "escapeHTML", function(e) {
      const t = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, r = /[&<>"']/g, s = RegExp(r.source);
      return e && s.test(e) ? e.replace(r, (i) => t[i]) : e;
    });
  }
  /**
   * @method stringify
   * @param  {Object} params
   * @param  {String} prefix
   * @param  {Boolean} isArray
   * @return {String} Stringified object
   */
  stringify(e, t, r) {
    const s = [];
    for (const i in e) {
      if (!Object.prototype.hasOwnProperty.call(e, i))
        continue;
      const n = e[i], l = r ? "" : encodeURIComponent(i);
      let a;
      typeof n == "object" ? a = this.stringify(
        n,
        t ? t + encodeURIComponent("[" + l + "]") : l,
        Array.isArray(n)
      ) : a = (t ? t + encodeURIComponent("[" + l + "]") : l) + "=" + encodeURIComponent(n), s.push(a);
    }
    return s.join("&");
  }
  /**
   * @method getRegionURL
   * @param  {String} regionCode region code, could be eu, us, cn, ap or ca
   * @return {String} The base URL of the region
   */
  getRegionURL(e) {
    const t = "api.storyblok.com", r = "api-us.storyblok.com", s = "app.storyblokchina.cn", i = "api-ap.storyblok.com", n = "api-ca.storyblok.com";
    switch (e) {
      case "us":
        return r;
      case "cn":
        return s;
      case "ap":
        return i;
      case "ca":
        return n;
      default:
        return t;
    }
  }
}
const A = function(o, e) {
  const t = {};
  for (const r in o) {
    const s = o[r];
    e.indexOf(r) > -1 && s !== null && (t[r] = s);
  }
  return t;
}, C = (o) => o === "email", O = () => ({
  singleTag: "hr"
}), L = () => ({
  tag: "blockquote"
}), E = () => ({
  tag: "ul"
}), H = (o) => ({
  tag: [
    "pre",
    {
      tag: "code",
      attrs: o.attrs
    }
  ]
}), U = () => ({
  singleTag: "br"
}), j = (o) => ({
  tag: `h${o.attrs.level}`
}), N = (o) => ({
  singleTag: [
    {
      tag: "img",
      attrs: A(o.attrs, ["src", "alt", "title"])
    }
  ]
}), I = () => ({
  tag: "li"
}), M = () => ({
  tag: "ol"
}), z = () => ({
  tag: "p"
}), q = (o) => ({
  tag: [
    {
      tag: "span",
      attrs: {
        "data-type": "emoji",
        "data-name": o.attrs.name,
        emoji: o.attrs.emoji
      }
    }
  ]
}), V = () => ({
  tag: "b"
}), F = () => ({
  tag: "s"
}), J = () => ({
  tag: "u"
}), B = () => ({
  tag: "strong"
}), K = () => ({
  tag: "code"
}), W = () => ({
  tag: "i"
}), G = (o) => {
  if (!o.attrs)
    return {
      tag: ""
    };
  const e = new k().escapeHTML, t = { ...o.attrs }, { linktype: r = "url" } = o.attrs;
  if (delete t.linktype, t.href && (t.href = e(o.attrs.href || "")), C(r) && (t.href = `mailto:${t.href}`), t.anchor && (t.href = `${t.href}#${t.anchor}`, delete t.anchor), t.custom) {
    for (const s in t.custom)
      t[s] = t.custom[s];
    delete t.custom;
  }
  return {
    tag: [
      {
        tag: "a",
        attrs: t
      }
    ]
  };
}, Y = (o) => ({
  tag: [
    {
      tag: "span",
      attrs: o.attrs
    }
  ]
}), Q = () => ({
  tag: "sub"
}), X = () => ({
  tag: "sup"
}), Z = (o) => ({
  tag: [
    {
      tag: "span",
      attrs: o.attrs
    }
  ]
}), D = (o) => {
  var t;
  return (t = o.attrs) != null && t.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `background-color:${o.attrs.color};`
        }
      }
    ]
  } : {
    tag: ""
  };
}, ee = (o) => {
  var t;
  return (t = o.attrs) != null && t.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `color:${o.attrs.color}`
        }
      }
    ]
  } : {
    tag: ""
  };
}, te = {
  nodes: {
    horizontal_rule: O,
    blockquote: L,
    bullet_list: E,
    code_block: H,
    hard_break: U,
    heading: j,
    image: N,
    list_item: I,
    ordered_list: M,
    paragraph: z,
    emoji: q
  },
  marks: {
    bold: V,
    strike: F,
    underline: J,
    strong: B,
    code: K,
    italic: W,
    link: G,
    styled: Y,
    subscript: Q,
    superscript: X,
    anchor: Z,
    highlight: D,
    textStyle: ee
  }
}, se = function(o) {
  const e = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  }, t = /[&<>"']/g, r = RegExp(t.source);
  return o && r.test(o) ? o.replace(t, (s) => e[s]) : o;
};
let T = !1;
class re {
  constructor(e) {
    c(this, "marks");
    c(this, "nodes");
    e || (e = te), this.marks = e.marks || [], this.nodes = e.nodes || [];
  }
  addNode(e, t) {
    this.nodes[e] = t;
  }
  addMark(e, t) {
    this.marks[e] = t;
  }
  render(e, t = { optimizeImages: !1 }, r = !0) {
    if (!T && r && (console.warn(
      "Warning ⚠️: The RichTextResolver class is deprecated and will be removed in the next major release. Please use the `@storyblok/richtext` package instead. https://github.com/storyblok/richtext/"
    ), T = !0), e && e.content && Array.isArray(e.content)) {
      let s = "";
      return e.content.forEach((i) => {
        s += this.renderNode(i);
      }), t.optimizeImages ? this.optimizeImages(s, t.optimizeImages) : s;
    }
    return console.warn(
      `The render method must receive an Object with a "content" field.
			The "content" field must be an array of nodes as the type ISbRichtext.
			ISbRichtext:
				content?: ISbRichtext[]
				marks?: ISbRichtext[]
				attrs?: any
				text?: string
				type: string
				
				Example:
				{
					content: [
						{
							content: [
								{
									text: 'Hello World',
									type: 'text'
								}
							],
							type: 'paragraph'
						}
					],
					type: 'doc'
				}`
    ), "";
  }
  optimizeImages(e, t) {
    let r = 0, s = 0, i = "", n = "";
    typeof t != "boolean" && (typeof t.width == "number" && t.width > 0 && (i += `width="${t.width}" `, r = t.width), typeof t.height == "number" && t.height > 0 && (i += `height="${t.height}" `, s = t.height), (t.loading === "lazy" || t.loading === "eager") && (i += `loading="${t.loading}" `), typeof t.class == "string" && t.class.length > 0 && (i += `class="${t.class}" `), t.filters && (typeof t.filters.blur == "number" && t.filters.blur >= 0 && t.filters.blur <= 100 && (n += `:blur(${t.filters.blur})`), typeof t.filters.brightness == "number" && t.filters.brightness >= -100 && t.filters.brightness <= 100 && (n += `:brightness(${t.filters.brightness})`), t.filters.fill && (t.filters.fill.match(/[0-9A-Fa-f]{6}/g) || t.filters.fill === "transparent") && (n += `:fill(${t.filters.fill})`), t.filters.format && ["webp", "png", "jpeg"].includes(t.filters.format) && (n += `:format(${t.filters.format})`), typeof t.filters.grayscale == "boolean" && t.filters.grayscale && (n += ":grayscale()"), typeof t.filters.quality == "number" && t.filters.quality >= 0 && t.filters.quality <= 100 && (n += `:quality(${t.filters.quality})`), t.filters.rotate && [90, 180, 270].includes(t.filters.rotate) && (n += `:rotate(${t.filters.rotate})`), n.length > 0 && (n = "/filters" + n))), i.length > 0 && (e = e.replace(/<img/g, `<img ${i.trim()}`));
    const l = r > 0 || s > 0 || n.length > 0 ? `${r}x${s}${n}` : "";
    return e = e.replace(
      /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|tiff|bmp)/g,
      `a.storyblok.com/f/$1/$2.$3/m/${l}`
    ), typeof t != "boolean" && (t.sizes || t.srcset) && (e = e.replace(/<img.*?src=["|'](.*?)["|']/g, (a) => {
      var h, f;
      const u = a.match(
        /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|tiff|bmp)/g
      );
      if (u && u.length > 0) {
        const d = {
          srcset: (h = t.srcset) == null ? void 0 : h.map((g) => {
            if (typeof g == "number")
              return `//${u}/m/${g}x0${n} ${g}w`;
            if (typeof g == "object" && g.length === 2) {
              let b = 0, _ = 0;
              return typeof g[0] == "number" && (b = g[0]), typeof g[1] == "number" && (_ = g[1]), `//${u}/m/${b}x${_}${n} ${b}w`;
            }
          }).join(", "),
          sizes: (f = t.sizes) == null ? void 0 : f.map((g) => g).join(", ")
        };
        let p = "";
        return d.srcset && (p += `srcset="${d.srcset}" `), d.sizes && (p += `sizes="${d.sizes}" `), a.replace(/<img/g, `<img ${p.trim()}`);
      }
      return a;
    })), e;
  }
  renderNode(e) {
    const t = [];
    e.marks && e.marks.forEach((s) => {
      const i = this.getMatchingMark(s);
      i && i.tag !== "" && t.push(this.renderOpeningTag(i.tag));
    });
    const r = this.getMatchingNode(e);
    return r && r.tag && t.push(this.renderOpeningTag(r.tag)), e.content ? e.content.forEach((s) => {
      t.push(this.renderNode(s));
    }) : e.text ? t.push(se(e.text)) : r && r.singleTag ? t.push(this.renderTag(r.singleTag, " /")) : r && r.html ? t.push(r.html) : e.type === "emoji" && t.push(this.renderEmoji(e)), r && r.tag && t.push(this.renderClosingTag(r.tag)), e.marks && e.marks.slice(0).reverse().forEach((s) => {
      const i = this.getMatchingMark(s);
      i && i.tag !== "" && t.push(this.renderClosingTag(i.tag));
    }), t.join("");
  }
  renderTag(e, t) {
    return e.constructor === String ? `<${e}${t}>` : e.map((s) => {
      if (s.constructor === String)
        return `<${s}${t}>`;
      {
        let i = `<${s.tag}`;
        if (s.attrs) {
          for (const n in s.attrs)
            if (Object.prototype.hasOwnProperty.call(s.attrs, n)) {
              const l = s.attrs[n];
              l !== null && (i += ` ${n}="${l}"`);
            }
        }
        return `${i}${t}>`;
      }
    }).join("");
  }
  renderOpeningTag(e) {
    return this.renderTag(e, "");
  }
  renderClosingTag(e) {
    return e.constructor === String ? `</${e}>` : e.slice(0).reverse().map((r) => r.constructor === String ? `</${r}>` : `</${r.tag}>`).join("");
  }
  getMatchingNode(e) {
    const t = this.nodes[e.type];
    if (typeof t == "function")
      return t(e);
  }
  getMatchingMark(e) {
    const t = this.marks[e.type];
    if (typeof t == "function")
      return t(e);
  }
  renderEmoji(e) {
    if (e.attrs.emoji)
      return e.attrs.emoji;
    const t = [
      {
        tag: "img",
        attrs: {
          src: e.attrs.fallbackImage,
          draggable: "false",
          loading: "lazy",
          align: "absmiddle"
        }
      }
    ];
    return this.renderTag(t, " /");
  }
}
const $ = re;
class ie {
  constructor(e) {
    c(this, "baseURL");
    c(this, "timeout");
    c(this, "headers");
    c(this, "responseInterceptor");
    c(this, "fetch");
    c(this, "ejectInterceptor");
    c(this, "url");
    c(this, "parameters");
    c(this, "fetchOptions");
    this.baseURL = e.baseURL, this.headers = e.headers || new Headers(), this.timeout = e != null && e.timeout ? e.timeout * 1e3 : 0, this.responseInterceptor = e.responseInterceptor, this.fetch = (...t) => e.fetch ? e.fetch(...t) : fetch(...t), this.ejectInterceptor = !1, this.url = "", this.parameters = {}, this.fetchOptions = {};
  }
  /**
   *
   * @param url string
   * @param params ISbStoriesParams
   * @returns Promise<ISbResponse | Error>
   */
  get(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("get");
  }
  post(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("post");
  }
  put(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("put");
  }
  delete(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("delete");
  }
  async _responseHandler(e) {
    const t = [], r = {
      data: {},
      headers: {},
      status: 0,
      statusText: ""
    };
    e.status !== 204 && await e.json().then((s) => {
      r.data = s;
    });
    for (const s of e.headers.entries())
      t[s[0]] = s[1];
    return r.headers = { ...t }, r.status = e.status, r.statusText = e.statusText, r;
  }
  async _methodHandler(e) {
    let t = `${this.baseURL}${this.url}`, r = null;
    if (e === "get") {
      const a = new k();
      t = `${this.baseURL}${this.url}?${a.stringify(
        this.parameters
      )}`;
    } else
      r = JSON.stringify(this.parameters);
    const s = new URL(t), i = new AbortController(), { signal: n } = i;
    let l;
    this.timeout && (l = setTimeout(() => i.abort(), this.timeout));
    try {
      const a = await this.fetch(`${s}`, {
        method: e,
        headers: this.headers,
        body: r,
        signal: n,
        ...this.fetchOptions
      });
      this.timeout && clearTimeout(l);
      const u = await this._responseHandler(
        a
      );
      return this.responseInterceptor && !this.ejectInterceptor ? this._statusHandler(this.responseInterceptor(u)) : this._statusHandler(u);
    } catch (a) {
      return {
        message: a
      };
    }
  }
  setFetchOptions(e = {}) {
    Object.keys(e).length > 0 && "method" in e && delete e.method, this.fetchOptions = { ...e };
  }
  eject() {
    this.ejectInterceptor = !0;
  }
  _statusHandler(e) {
    const t = /20[0-6]/g;
    return new Promise((r, s) => {
      if (t.test(`${e.status}`))
        return r(e);
      const i = {
        message: e.statusText,
        status: e.status,
        response: Array.isArray(e.data) ? e.data[0] : e.data.error || e.data.slug
      };
      s(i);
    });
  }
}
const ne = ie, w = "SB-Agent", R = {
  defaultAgentName: "SB-JS-CLIENT",
  defaultAgentVersion: "SB-Agent-Version",
  packageVersion: "6.0.0"
};
let m = {};
const y = {};
class ae {
  /**
   *
   * @param config ISbConfig interface
   * @param endpoint string, optional
   */
  constructor(e, t) {
    c(this, "client");
    c(this, "maxRetries");
    c(this, "retriesDelay");
    c(this, "throttle");
    c(this, "accessToken");
    c(this, "cache");
    c(this, "helpers");
    c(this, "resolveCounter");
    c(this, "relations");
    c(this, "links");
    // TODO: Remove on v7.x.x
    c(this, "richTextResolver");
    c(this, "resolveNestedRelations");
    c(this, "stringifiedStoriesCache");
    let r = e.endpoint || t;
    if (!r) {
      const n = new k().getRegionURL, l = e.https === !1 ? "http" : "https";
      e.oauthToken ? r = `${l}://${n(e.region)}/v1` : r = `${l}://${n(e.region)}/v2`;
    }
    const s = new Headers();
    s.set("Content-Type", "application/json"), s.set("Accept", "application/json"), e.headers && (e.headers.constructor.name === "Headers" ? e.headers.entries().toArray() : Object.entries(e.headers)).forEach(([l, a]) => {
      s.set(l, a);
    }), s.has(w) || (s.set(w, R.defaultAgentName), s.set(
      R.defaultAgentVersion,
      R.packageVersion
    ));
    let i = 5;
    e.oauthToken && (s.set("Authorization", e.oauthToken), i = 3), e.rateLimit && (i = e.rateLimit), e.richTextSchema ? this.richTextResolver = new $(e.richTextSchema) : this.richTextResolver = new $(), e.componentResolver && this.setComponentResolver(e.componentResolver), this.maxRetries = e.maxRetries || 10, this.retriesDelay = 300, this.throttle = P(this.throttledRequest, i, 1e3), this.accessToken = e.accessToken || "", this.relations = {}, this.links = {}, this.cache = e.cache || { clear: "manual" }, this.helpers = new k(), this.resolveCounter = 0, this.resolveNestedRelations = e.resolveNestedRelations || !0, this.stringifiedStoriesCache = {}, this.client = new ne({
      baseURL: r,
      timeout: e.timeout || 0,
      headers: s,
      responseInterceptor: e.responseInterceptor,
      fetch: e.fetch
    });
  }
  setComponentResolver(e) {
    this.richTextResolver.addNode("blok", (t) => {
      let r = "";
      return t.attrs.body && t.attrs.body.forEach((s) => {
        r += e(s.component, s);
      }), {
        html: r
      };
    });
  }
  parseParams(e) {
    return e.token || (e.token = this.getToken()), e.cv || (e.cv = y[e.token]), Array.isArray(e.resolve_relations) && (e.resolve_relations = e.resolve_relations.join(",")), typeof e.resolve_relations < "u" && (e.resolve_level = 2), e;
  }
  factoryParamOptions(e, t) {
    return this.helpers.isCDNUrl(e) ? this.parseParams(t) : t;
  }
  makeRequest(e, t, r, s, i) {
    const n = this.factoryParamOptions(
      e,
      this.helpers.getOptionsPage(t, r, s)
    );
    return this.cacheResponse(e, n, void 0, i);
  }
  get(e, t, r) {
    t || (t = {});
    const s = `/${e}`, i = this.factoryParamOptions(s, t);
    return this.cacheResponse(s, i, void 0, r);
  }
  async getAll(e, t, r, s) {
    const i = (t == null ? void 0 : t.per_page) || 25, n = `/${e}`, l = n.split("/"), a = r || l[l.length - 1], u = 1, h = await this.makeRequest(
      n,
      t,
      i,
      u,
      s
    ), f = h.total ? Math.ceil(h.total / i) : 1, d = await this.helpers.asyncMap(
      this.helpers.range(u, f),
      (p) => this.makeRequest(n, t, i, p + 1, s)
    );
    return this.helpers.flatMap(
      [h, ...d],
      (p) => Object.values(p.data[a])
    );
  }
  post(e, t, r) {
    const s = `/${e}`;
    return Promise.resolve(this.throttle("post", s, t, r));
  }
  put(e, t, r) {
    const s = `/${e}`;
    return Promise.resolve(this.throttle("put", s, t, r));
  }
  delete(e, t, r) {
    const s = `/${e}`;
    return Promise.resolve(this.throttle("delete", s, t, r));
  }
  getStories(e, t) {
    return this._addResolveLevel(e), this.get("cdn/stories", e, t);
  }
  getStory(e, t, r) {
    return this._addResolveLevel(t), this.get(`cdn/stories/${e}`, t, r);
  }
  getToken() {
    return this.accessToken;
  }
  ejectInterceptor() {
    this.client.eject();
  }
  _addResolveLevel(e) {
    typeof e.resolve_relations < "u" && (e.resolve_level = 2);
  }
  _cleanCopy(e) {
    return JSON.parse(JSON.stringify(e));
  }
  _insertLinks(e, t, r) {
    const s = e[t];
    s && s.fieldtype == "multilink" && s.linktype == "story" && typeof s.id == "string" && this.links[r][s.id] ? s.story = this._cleanCopy(this.links[r][s.id]) : s && s.linktype === "story" && typeof s.uuid == "string" && this.links[r][s.uuid] && (s.story = this._cleanCopy(this.links[r][s.uuid]));
  }
  /**
   *
   * @param resolveId A counter number as a string
   * @param uuid The uuid of the story
   * @returns string | object
   */
  getStoryReference(e, t) {
    return this.relations[e][t] ? (this.stringifiedStoriesCache[t] || (this.stringifiedStoriesCache[t] = JSON.stringify(
      this.relations[e][t]
    )), JSON.parse(this.stringifiedStoriesCache[t])) : t;
  }
  _insertRelations(e, t, r, s) {
    r.indexOf(`${e.component}.${t}`) > -1 && (typeof e[t] == "string" ? e[t] = this.getStoryReference(s, e[t]) : Array.isArray(e[t]) && (e[t] = e[t].map((i) => this.getStoryReference(s, i)).filter(Boolean)));
  }
  iterateTree(e, t, r) {
    const s = (i) => {
      if (i != null) {
        if (i.constructor === Array)
          for (let n = 0; n < i.length; n++)
            s(i[n]);
        else if (i.constructor === Object) {
          if (i._stopResolving)
            return;
          for (const n in i)
            (i.component && i._uid || i.type === "link") && (this._insertRelations(
              i,
              n,
              t,
              r
            ), this._insertLinks(
              i,
              n,
              r
            )), s(i[n]);
        }
      }
    };
    s(e.content);
  }
  async resolveLinks(e, t, r) {
    let s = [];
    if (e.link_uuids) {
      const i = e.link_uuids.length, n = [], l = 50;
      for (let a = 0; a < i; a += l) {
        const u = Math.min(i, a + l);
        n.push(e.link_uuids.slice(a, u));
      }
      for (let a = 0; a < n.length; a++)
        (await this.getStories({
          per_page: l,
          language: t.language,
          version: t.version,
          by_uuids: n[a].join(",")
        })).data.stories.forEach(
          (h) => {
            s.push(h);
          }
        );
    } else
      s = e.links;
    s.forEach((i) => {
      this.links[r][i.uuid] = {
        ...i,
        _stopResolving: !0
      };
    });
  }
  async resolveRelations(e, t, r) {
    let s = [];
    if (e.rel_uuids) {
      const i = e.rel_uuids.length, n = [], l = 50;
      for (let a = 0; a < i; a += l) {
        const u = Math.min(i, a + l);
        n.push(e.rel_uuids.slice(a, u));
      }
      for (let a = 0; a < n.length; a++)
        (await this.getStories({
          per_page: l,
          language: t.language,
          version: t.version,
          by_uuids: n[a].join(","),
          excluding_fields: t.excluding_fields
        })).data.stories.forEach((h) => {
          s.push(h);
        });
    } else
      s = e.rels;
    s && s.length > 0 && s.forEach((i) => {
      this.relations[r][i.uuid] = {
        ...i,
        _stopResolving: !0
      };
    });
  }
  /**
   *
   * @param responseData
   * @param params
   * @param resolveId
   * @description Resolves the relations and links of the stories
   * @returns Promise<void>
   *
   */
  async resolveStories(e, t, r) {
    var i, n;
    let s = [];
    if (this.links[r] = {}, this.relations[r] = {}, typeof t.resolve_relations < "u" && t.resolve_relations.length > 0 && (typeof t.resolve_relations == "string" && (s = t.resolve_relations.split(",")), await this.resolveRelations(e, t, r)), t.resolve_links && ["1", "story", "url", "link"].indexOf(t.resolve_links) > -1 && ((i = e.links) != null && i.length || (n = e.link_uuids) != null && n.length) && await this.resolveLinks(e, t, r), this.resolveNestedRelations)
      for (const l in this.relations[r])
        this.iterateTree(
          this.relations[r][l],
          s,
          r
        );
    e.story ? this.iterateTree(e.story, s, r) : e.stories.forEach((l) => {
      this.iterateTree(l, s, r);
    }), this.stringifiedStoriesCache = {}, delete this.links[r], delete this.relations[r];
  }
  async cacheResponse(e, t, r, s) {
    const i = this.helpers.stringify({ url: e, params: t }), n = this.cacheProvider();
    if (this.cache.clear === "auto" && t.version === "draft" && await this.flushCache(), t.version === "published" && e != "/cdn/spaces/me") {
      const l = await n.get(i);
      if (l)
        return Promise.resolve(l);
    }
    return new Promise(async (l, a) => {
      var u;
      try {
        const h = await this.throttle("get", e, t, s);
        if (h.status !== 200)
          return a(h);
        let f = { data: h.data, headers: h.headers };
        if ((u = h.headers) != null && u["per-page"] && (f = Object.assign({}, f, {
          perPage: h.headers["per-page"] ? parseInt(h.headers["per-page"]) : 0,
          total: h.headers["per-page"] ? parseInt(h.headers.total) : 0
        })), f.data.story || f.data.stories) {
          const d = this.resolveCounter = ++this.resolveCounter % 1e3;
          await this.resolveStories(f.data, t, `${d}`);
        }
        return t.version === "published" && e != "/cdn/spaces/me" && await n.set(i, f), f.data.cv && t.token && y[t.token] != f.data.cv && (await this.flushCache(), y[t.token] = f.data.cv), l(f);
      } catch (h) {
        if (h.response && h.status === 429 && (r = typeof r > "u" ? 0 : r + 1, r < this.maxRetries))
          return console.log(
            `Hit rate limit. Retrying in ${this.retriesDelay / 1e3} seconds.`
          ), await this.helpers.delay(this.retriesDelay), this.cacheResponse(e, t, r).then(l).catch(a);
        a(h);
      }
    });
  }
  throttledRequest(e, t, r, s) {
    return this.client.setFetchOptions(s), this.client[e](t, r);
  }
  cacheVersions() {
    return y;
  }
  cacheVersion() {
    return y[this.accessToken];
  }
  setCacheVersion(e) {
    this.accessToken && (y[this.accessToken] = e);
  }
  clearCacheVersion() {
    this.accessToken && (y[this.accessToken] = 0);
  }
  cacheProvider() {
    switch (this.cache.type) {
      case "memory":
        return {
          get(e) {
            return Promise.resolve(m[e]);
          },
          getAll() {
            return Promise.resolve(m);
          },
          set(e, t) {
            return m[e] = t, Promise.resolve(void 0);
          },
          flush() {
            return m = {}, Promise.resolve(void 0);
          }
        };
      case "custom":
        if (this.cache.custom) return this.cache.custom;
      default:
        return {
          get() {
            return Promise.resolve();
          },
          getAll() {
            return Promise.resolve(void 0);
          },
          set() {
            return Promise.resolve(void 0);
          },
          flush() {
            return Promise.resolve(void 0);
          }
        };
    }
  }
  async flushCache() {
    return await this.cacheProvider().flush(), this.clearCacheVersion(), this;
  }
}



/***/ })

}]);